export default "__VITE_ASSET__DiVUNf1y__"